import { gql } from 'react-apollo';

export default gql`
  mutation logoutShared($token: String!) {
    logoutShared(token: $token)
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/mutations/logoutShared.js